// extracted by mini-css-extract-plugin
module.exports = {"header":"style_header__MlSQ_","container":"style_container__3TbXE","title":"style_title__dZdD7","description":"style_description__-_ppP","shadowBox":"style_shadowBox__2Met0"};